import { render, staticRenderFns } from "./videodeurbelinbraakonderzoekHome.vue?vue&type=template&id=0751d511"
import script from "./videodeurbelinbraakonderzoekHome.vue?vue&type=script&lang=js"
export * from "./videodeurbelinbraakonderzoekHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports